module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-noneheader"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("用户管理")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/user/userList'
      }
    }
  }, [_vm._v("用户列表")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("用户信息")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticStyle: {
      "width": "auto",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "form-default",
    attrs: {
      "model": _vm.vo,
      "label-width": "150px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "name",
      "rules": [{
        required: true,
        message: '请输入',
        trigger: 'blur'
      }, {
        min: 2,
        max: 20,
        message: '长度在 2 到 20 个字符',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.vo.name),
      callback: function($$v) {
        _vm.$set(_vm.vo, "name", $$v)
      },
      expression: "vo.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机",
      "prop": "phone",
      "rules": [{
        required: true,
        message: '请输入',
        trigger: 'blur'
      }, {
        min: 11,
        max: 11,
        message: '请输入11位手机号码',
        trigger: 'blur'
      }, {
        pattern: /^1[3456789]\d{9}$/,
        message: '请输入正确的手机号码'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.vo.phone),
      callback: function($$v) {
        _vm.$set(_vm.vo, "phone", $$v)
      },
      expression: "vo.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型",
      "prop": "type",
      "rules": [{
        required: true,
        message: '请选择',
        trigger: 'blur'
      }]
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.vo.id
    },
    model: {
      value: (_vm.vo.type),
      callback: function($$v) {
        _vm.$set(_vm.vo, "type", $$v)
      },
      expression: "vo.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "平台管理员",
      "value": "ORDINARY"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "学校管理员",
      "value": "SCHOOL_ADMIN"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.vo.type == 'SCHOOL_ADMIN') ? _c('span', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学校",
      "prop": "departmentId",
      "rules": [{
        required: true,
        message: '请选择',
        trigger: 'blur'
      }]
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "autocomplete": "",
      "filterable": ""
    },
    model: {
      value: (_vm.vo.departmentId),
      callback: function($$v) {
        _vm.$set(_vm.vo, "departmentId", $$v)
      },
      expression: "vo.departmentId"
    }
  }, _vm._l((_vm.departmentList), function(d) {
    return _c('el-option', {
      key: d.id,
      attrs: {
        "label": d.name,
        "value": d.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "员工号",
      "prop": "schoolNo",
      "rules": [{
        required: true,
        message: '请输入',
        trigger: 'blur'
      }, {
        min: 2,
        max: 20,
        message: '长度在 2 到 20 个字符',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.vo.schoolNo),
      callback: function($$v) {
        _vm.$set(_vm.vo, "schoolNo", $$v)
      },
      expression: "vo.schoolNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学校部门",
      "prop": "schoolDeptName",
      "rules": [{
        min: 2,
        max: 20,
        message: '长度在 2 到 20 个字符',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.vo.schoolDeptName),
      callback: function($$v) {
        _vm.$set(_vm.vo, "schoolDeptName", $$v)
      },
      expression: "vo.schoolDeptName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "人员性质",
      "prop": "nature",
      "rules": [{
        min: 2,
        max: 20,
        message: '长度在 2 到 20 个字符',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.vo.nature),
      callback: function($$v) {
        _vm.$set(_vm.vo, "nature", $$v)
      },
      expression: "vo.nature"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "银行账号",
      "prop": "account",
      "rules": [{
        min: 2,
        max: 30,
        message: '长度在 2 到 30 个字符',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.vo.account),
      callback: function($$v) {
        _vm.$set(_vm.vo, "account", $$v)
      },
      expression: "vo.account"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f06682b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/user/UserModify.vue
// module id = 455
// module chunks = 2